export class SuccessDialogData {
  message!: string;
  title?: string;
  duration?: number;
}
